import { useState } from "react";
import { api } from "../lib/api";
import { Languages, Loader2 } from "lucide-react";

const TARGETS = [
  { value: "english", label: "English" },
  { value: "shona", label: "Shona" },
  { value: "ndebele", label: "Ndebele" },
];

// One-tap inline translate for any short text (inbox messages, notes).
export function TranslateButton({ text, testid = "translate-btn-inline" }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [out, setOut] = useState("");
  const run = async (target) => {
    setOpen(false); setBusy(true); setOut("");
    try {
      const { data } = await api.post("/ai/translate", { text: String(text || "").slice(0, 4000), target });
      setOut(data.translation);
    } catch { setOut("Translation unavailable right now."); }
    finally { setBusy(false); }
  };
  if (!text) return null;
  return (
    <span className="inline-block relative">
      <button type="button" onClick={() => setOpen((v) => !v)} data-testid={testid}
        className="inline-flex items-center gap-0.5 text-[10px] font-semibold opacity-70 hover:opacity-100 underline decoration-dotted">
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Languages className="w-3 h-3" />} Translate
      </button>
      {open && (
        <span className="absolute z-20 mt-1 left-0 bg-white border border-line rounded-md shadow-lg p-1 flex flex-col min-w-[110px]" data-testid={`${testid}-menu`}>
          {TARGETS.map((t) => (
            <button key={t.value} type="button" onClick={() => run(t.value)}
              className="text-left text-xs text-ink hover:bg-sand rounded px-2 py-1">{t.label}</button>
          ))}
        </span>
      )}
      {out && (
        <span className="block mt-1 text-xs italic bg-white/60 border-l-2 border-clinical/50 pl-2 py-0.5 rounded" data-testid={`${testid}-output`}>
          {out}
        </span>
      )}
    </span>
  );
}
